<template>
  <div class="super_container">
    <link rel="stylesheet" type="text/css" href="styles/offers_styles.css" />
    <link rel="stylesheet" type="text/css" href="styles/offers_responsive.css" />
    <!-- Home -->

    <div class="home">
      <!-- Image by https://unsplash.com/@peecho -->
      <div
        class="home_background parallax-window"
        data-parallax="scroll"
        style="background-image: url(images/offers.jpg)"
        data-speed="0.8"
      ></div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="home_content">
              <div class="home_content_inner">
                <div class="home_title">Oferty</div>
                <div class="home_breadcrumbs">
                  <ul class="home_breadcrumbs_list">
                    <li class="home_breadcrumb"><a href="index.html">Marena</a></li>
                    <li class="home_breadcrumb">Oferty</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Find Form -->

    <TripContact />

    <!-- Offers -->

    <div class="offers">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title text-center">
              <h2>Miejca które warto zobaczyć</h2>
              <div>nasze oferty</div>
            </div>
          </div>
        </div>
        <div class="row filtering_row">
          <div class="col">
            <div class="sorting_group_2 clearfix">
              <div class="sorting_icons clearfix">
                <div class="detail_view"><i class="fa fa-bars" aria-hidden="true"></i></div>
                <div class="box_view"><i class="fa fa-th-large" aria-hidden="true"></i></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="items item_grid clearfix">
              <!-- Item -->
              <div
                v-for="trip in trips"
                v-show="!loading && trips.length"
                :key="trip.id"
                class="item clearfix rating_5"
              >
                <div class="item_image">
                  <MImage
                    :default-img="trip.thumbnail_photo"
                    alt="zdjęcie wycieczki"
                    :trip="trip"
                  />
                </div>
                <div class="item_content">
                  <div v-show="trip.price" class="item_price">{{ trip.price }} zł</div>
                  <div class="item_title">{{ trip.title }}</div>
                  <ul>
                    <li>{{ trip.start_date }} - {{ trip.end_date }}</li>
                  </ul>
                  <div class="item_text" v-html="trip.description"></div>
                  <div class="item_more_link">
                    <router-link :to="{ name: 'trip', params: { id: trip.id } }">
                      Więcej...
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="item clearfix rating_5">
                <div v-show="loggedUser" class="controls">
                  <button class="m-button" @click="goToNewTrip">Dodaj</button>
                </div>
              </div>
            </div>
            <div class="m-loading-status">
              <i v-show="loading" class="fa fa-spinner fa-spin" data-cy="loading-spinner" />
              <h2 v-show="!loading && !trips.length">Brak danych</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="pages">
              <ul class="pages_list">
                <li v-for="page in pages" :key="page" class="page active">
                  <a href="void::" @click="fetchTrips(page)">{{ page }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <script2 src="plugins/Isotope/isotope.pkgd.min.js"></script2>
    <script2 src="plugins/scrollmagic/ScrollMagic.min.js"></script2>
    <script2 src="js/offers_custom.js"></script2>
  </div>
</template>

<script>
import TripContact from '@/components/TripContact.vue'
import MImage from '@/components/MImage.vue'
import { mapState } from 'vuex'
import cli from '@/http.js'

export default {
  name: 'Offers',
  components: {
    TripContact,
    MImage,
  },
  data() {
    return {
      trips: [],
      numberOfPages: 1,
      loading: true,
    }
  },
  computed: {
    ...mapState(['loggedUser']),
    pages() {
      const pages = []
      for (let item = 1; item < this.numberOfPages; item++) {
        pages.push(item)
      }
      return pages
    },
  },
  async mounted() {
    await this.fetchTrips()
  },
  methods: {
    goToNewTrip() {
      this.$router.push({
        name: 'trip',
        params: {
          id: 'new',
        },
      })
    },
    async fetchTrips(pageNumber = 1) {
      this.loading = true
      try {
        let queryParams = `?page=${pageNumber}`
        if (this.$route.query) {
          queryParams += '&' + new URLSearchParams(this.$route.query).toString()
        }
        const resp = await cli.get(`/trips/${queryParams}`)
        this.trips = resp.data.results
        this.numberOfPages = resp.data.count / resp.data.results.length || 1
      } catch (err) {
        this.$notify({
          title: 'Błąd',
          text: err.message,
          type: 'error',
        })
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.controls {
  position: absolute;
  bottom: 0;
  right: 0;
}
.item {
  width: 100%;
}
.item_image {
  height: 380px;
  min-width: 280px;
}
.item_text {
  max-height: 310px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.item_image img {
  object-fit: cover;
  height: 100%;
}
</style>
